import ManajemenPengguna from './ManajemenPengguna';
import ProfilPengguna from './ProfilPengguna';
import TukarPengguna from './TukarPengguna';
import FormPengguna from './FormPengguna';
import BackupRestore from './BackupRestore';
import DaftarPdDapodik from './DaftarPdDapodik';
import DaftarPtkDapodik from './DaftarPtkDapodik';

export const PengaturanConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes  : [
        {
            path     : '/ProfilPengguna',
            component: ProfilPengguna
        }
        ,{
            path     : '/ManajemenPengguna',
            component: ManajemenPengguna
        }
        ,{
            path     : '/TukarPengguna',
            component: TukarPengguna
        }
        ,{
            path     : '/TambahPengguna',
            component: FormPengguna
        }
        ,{
            path     : '/BackupRestore',
            component: BackupRestore
        }
        ,{
            path     : '/DaftarPdDapodik/:sekolah_id',
            component: DaftarPdDapodik
        }
        ,{
            path     : '/DaftarPtkDapodik/:sekolah_id',
            component: DaftarPtkDapodik
        }
    ]
};



// WEBPACK FOOTER //
// ./src/main/content/Pengaturan/PengaturanConfig.js